import { Link2, Mail, X } from 'lucide-react';
import { KeyHint } from './DrawerControls';

interface HeaderProps {
  threadCount: number;
  onClose: () => void;
}

/** Intestazione del pannello: cosa si sta collegando e come si chiude. */
export function DrawerHeader({ threadCount, onClose }: HeaderProps) {
  return (
    <div className="px-5 py-3 border-b border-black/[0.06] dark:border-gray-700 flex items-center justify-between bg-[#FBFBFA] dark:bg-gray-900/60">
      <div className="flex items-center gap-2 min-w-0">
        <span className="w-6 h-6 rounded-md bg-[#2383E2]/10 flex items-center justify-center flex-shrink-0">
          <Link2 className="h-3.5 w-3.5 text-[#2383E2]" />
        </span>
        <span className="text-[11px] uppercase tracking-wide font-semibold text-[#787774] dark:text-white/50">
          Collega {threadCount > 1 ? `${threadCount} email` : 'a'}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <span className="hidden sm:inline-flex items-center gap-1 text-[11px] text-[#9B9A97] dark:text-white/30">
          <KeyHint>esc</KeyHint>
        </span>
        <button
          onClick={onClose}
          className="p-1 rounded-md text-[#787774] dark:text-white/50 hover:text-[#37352F] dark:hover:text-white hover:bg-black/[0.05] dark:hover:bg-white/[0.08] transition-colors"
          title="Chiudi (Esc)"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

interface ContextProps {
  subject: string;
  who: string;
  messageCount: number;
}

/** Riquadro con il thread di partenza, per non perdere di vista cosa si sta collegando. */
export function DrawerThreadContext({ subject, who, messageCount }: ContextProps) {
  return (
    <div className="px-5 py-3 border-b border-black/[0.06] dark:border-gray-700">
      <div className="flex items-start gap-2.5">
        <div className="w-8 h-8 rounded-full bg-[rgba(55,53,47,0.06)] dark:bg-white/10 flex items-center justify-center flex-shrink-0">
          <Mail className="h-4 w-4 text-[#787774]" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-[#37352F] dark:text-white truncate">{subject}</p>
          <p className="text-xs text-[#787774] dark:text-white/40 truncate">
            {who} · {messageCount} {messageCount === 1 ? 'messaggio' : 'messaggi'}
          </p>
        </div>
      </div>
    </div>
  );
}
